import React from "react";
import { Form, Popover, Modal } from "antd";
import classNames from "classnames";

import { connect } from "react-redux";

class Other extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEnable: false,
            preferWallet: "",
            fromWalletList: [],
        };
    }
    componentDidMount() {
        // GetWalletList((res) => {
        // 	this.setState(
        // 		{
        // 			fromWalletList: res.result.fromWallet
        // 		},
        // 		() => {
        // 			this.props.memberInfo.preferWallet &&
        // 				this.setState({ preferWallet: this.props.memberInfo.preferWallet });
        // 			this.props.setLoading(false);
        // 		}
        // 	);
        // });
    }

    render() {
        const { secretQID, securityAnswer } = this.props.memberInfo;
        const { blanceModalVisible, closable, balanceList } = this.props;

        return (
            <Modal
                title={`其他钱包`}
                className="modal-pubilc BalanceList"
                visible={blanceModalVisible}
                closable={true}
                centered={true}
                width={400}
                footer={null}
                zIndex={1500}
                onCancel={() => {
                    closable();
                }}
            >
                <div className="Content">
                    {balanceList && balanceList.length
                        ? balanceList.map((val, index) => {
                              if (
                                  val.category === "Main" ||
                                  val.category === "TotalBal"
                              )
                                  return null;
                              return (
                                  <div
                                      
                                      key={"walletTransfer" + index}
                                      className={classNames({
                                          "balance-box": true,
                                          UnderMaintenance:
                                              val.state == "UnderMaintenance",
                                      })}
                                  >
                                      <div>
                                          <span className="localizedName">
                                              {val.localizedName}
                                          </span>
                                          {val.name === "SB" ? (
                                              <Popover
                                                  overlayStyle={{
                                                      zIndex: 1000,
                                                  }}
                                                  align={{ offset: [-4, 0] }}
                                                  placement="bottomLeft"
                                                  overlayClassName="popover-dark"
                                                  content={
                                                      <div>
                                                          包含 沙巴体育, BTI
                                                          体育, IM 体育和电竞
                                                      </div>
                                                  }
                                                  title=""
                                                  trigger="hover"
                                              >
                                                  <span className="header-popover-inner-tip pointer">
                                                      <img src="/cn/img/icon/note.svg" />
                                                  </span>
                                              </Popover>
                                          ) : null}
                                          {val.name === "P2P" ? (
                                              <Popover
                                                  overlayStyle={{
                                                      zIndex: 1000,
                                                  }}
                                                  align={{ offset: [-4, 0] }}
                                                  placement="bottomLeft"
                                                  overlayClassName="popover-dark"
                                                  content={
                                                      <div>
                                                          包含乐天使棋牌, 双赢棋牌，开元棋牌和小游戏
                                                      </div>
                                                  }
                                                  title=""
                                                  trigger="hover"
                                              >
                                                  <span className="header-popover-inner-tip pointer">
                                                      <img src="/cn/img/icon/note.svg" />
                                                  </span>
                                              </Popover>
                                          ) : null}
                                          {val.name.toLowerCase() === "keno" ? (
                                              <Popover
                                                  overlayStyle={{
                                                      zIndex: 1000,
                                                  }}
                                                  align={{ offset: [-4, 0] }}
                                                  placement="bottomLeft"
                                                  overlayClassName="popover-dark"
                                                  content={
                                                      <div>
                                                          包含双赢彩票和LB快乐彩​
                                                      </div>
                                                  }
                                                  title=""
                                                  trigger="hover"
                                              >
                                                  <span className="header-popover-inner-tip pointer">
                                                      <img src="/cn/img/icon/note.svg" />
                                                  </span>
                                              </Popover>
                                          ) : null}
                                      </div>
                                      <div className="num">
                                          {val.state === "UnderMaintenance"
                                              ? "维护中"
                                              : "￥" + val.balance}
                                      </div>
                                      <div className="btn" />
                                  </div>
                              );
                          })
                        : null}
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        memberInfo: state.userCenter.memberInfo,
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create({ name: "Other" })(Other));
